import {
    COMMUNICATIONS_ERROR,
    FETCH_COMMUNICATIONS_REQUEST,
    GET_COMMENTS,
    GET_COMMENT_TEXT,
    GET_COMMUNICATION_LIST,
    GET_EMPTY_COMMUNICATION,
    GET_SELECTED_COMMUNICATION_PARTNER,
    IS_PARTNER_CONNECTED,
    IS_VIEW_ADDING_NEW_COMMUNICATION,
    SET_COMMUNICATION_ACTIVITY,
    SET_COMMUNICATION_STATUS,
    SET_INCLUDE_CLOSED_COMMUNICATIONS,
    SET_IS_COMMUNICAITON_PARTNER_SELECTED,
    SET_MENTIONABLE_COMMENT_USERS,
    SET_SELECTED_COMMUNICATION,
    STORE_ADDED_COMMUNICATION,
    STORE_ADDED_REQUEST,
    UPDATE_STORED_COMMUNICATIONS,
    UPDATE_STORED_REQUESTS,
} from '../ActionTypes';

const initActions = function (services) {
    const axiosCall = services.axios.Axios();

    const getSelectedCommunicationPartner = (selectedPartner) => {
        return {
            type: GET_SELECTED_COMMUNICATION_PARTNER,
            payload: selectedPartner,
        };
    };

    const fetchCommunicationsRequest = () => {
        return {
            type: FETCH_COMMUNICATIONS_REQUEST,
        };
    };

    const isPartnerConnected = (status) => {
        return {
            type: IS_PARTNER_CONNECTED,
            payload: status,
        };
    };

    const getCommentText = (comment) => {
        return {
            type: GET_COMMENT_TEXT,
            payload: comment,
        };
    };

    const communicationsError = (error) => {
        return {
            type: COMMUNICATIONS_ERROR,
            payload: error,
        };
    };

    const getCommunicationsList = (communicationList) => {
        return {
            type: GET_COMMUNICATION_LIST,
            payload: communicationList,
        };
    };

    const getComments = (comments) => {
        return {
            type: GET_COMMENTS,
            payload: comments,
        };
    };

    const setSelectedCommunication = (communication) => {
        return {
            type: SET_SELECTED_COMMUNICATION,
            payload: communication,
        };
    };

    const setCommunicationStatus = (status) => {
        return {
            type: SET_COMMUNICATION_STATUS,
            payload: status,
        };
    };

    const setIsViewAddingCommunication = (practiceId, status) => {
        return {
            type: IS_VIEW_ADDING_NEW_COMMUNICATION,
            payload: { practiceId, status },
        };
    };

    const getEmptyCommunication = (emptyCommunication) => {
        return {
            type: GET_EMPTY_COMMUNICATION,
            payload: emptyCommunication,
        };
    };

    const updateStoredCommunications = (communication) => {
        return {
            type: UPDATE_STORED_COMMUNICATIONS,
            payload: communication,
        };
    };

    const updateStoredRequests = (request) => {
        return {
            type: UPDATE_STORED_REQUESTS,
            payload: request,
        };
    };

    const storeAddedCommunication = (communication) => {
        return {
            type: STORE_ADDED_COMMUNICATION,
            payload: communication,
        };
    };

    const storeAddedRequest = (request) => {
        return {
            type: STORE_ADDED_REQUEST,
            payload: request,
        };
    };

    const setIsCommunicationPartnerSelected = (status) => {
        return {
            type: SET_IS_COMMUNICAITON_PARTNER_SELECTED,
            payload: status,
        };
    };

    const fetchCommunication = (communicationId) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.get(
                    `Communications/${communicationId}`
                );
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(communicationsError(errorMsg));
            }
        };
    };

    const fetchComments = (communicationId) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.get(
                    `Communications/${communicationId}`
                );
                const comments = response.data.data;
                dispatch(setSelectedCommunication(response.data.data));
                dispatch(getComments(comments.comments));
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(communicationsError(errorMsg));
            }
        };
    };

    const readCommunicationComments = (communicationId) => {
        return async (dispatch) => {
            try {
                await axiosCall.post(`communications/${communicationId}/read`);
            } catch (error) {
                const errorMsg = error.message;
                dispatch(communicationsError(errorMsg));
            }
        };
    };

    const fetchCommunicationsList = (
        practiceID,
        includeClosedCommunications = false,
        selectedCommunication = null
    ) => {
        return async (dispatch) => {
            try {
                //dispatch(fetchCommunicationsRequest);
                let communications = [];
                if (practiceID) {
                    var response = await axiosCall.get(
                        `practices/${practiceID}/communications?includeClosedCommunications=${includeClosedCommunications}`
                    );
                    communications = response.data.data;
                }
                //dispatch(getCommunicationsList(communications));
                return communications;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(communicationsError(errorMsg));
            }
        };
    };

    const getCommunications =
        (practiceId, includeClosedCommunications = false) =>
        async () => {
            let params = {
                practiceId: practiceId,
            };
            if (includeClosedCommunications === true)
                params.includeClosedCommunications = true;
            return axiosCall.get('communications', {
                params: params,
            });
        };

    const createNewCommunication = (payload) => async () =>
        axiosCall.post('communications', payload, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });

    const getCommunication = (communicationId) => async () =>
        axiosCall.get('communications/' + communicationId);

    const postCommunicationComment = (communicationId, payload) => async () =>
        axiosCall.post(`communications/${communicationId}/comment`, payload, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });

    const setMentionableUsers = (users) => {
        return {
            type: SET_MENTIONABLE_COMMENT_USERS,
            payload: users,
        };
    };

    const getCommunicationUsers = (communicationId) => async () =>
        axiosCall.get('communications/' + communicationId + '/users');

    const getMentionableUsers = (practiceId, partnerId) => {
        return async (dispatch) => {
            if (partnerId !== undefined && partnerId !== null) {
                const response = await axiosCall.get(
                    `communications/users?practiceId=${practiceId}&partnerId=${partnerId}`
                );
                dispatch(setMentionableUsers(response.data.data));
            }
        };
    };

    const getCommunicationPartners = (practiceId) => async () =>
        axiosCall.get('communications/' + practiceId + '/partners');

    /*
    const getCommunicationPartners = (practiceId) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.get(
                    `communications/${practiceId}/partners`
                );
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(communicationsError(errorMsg));
            }
        };
    };
    */

    const setIncludeClosedCommunications = (status) => {
        return {
            type: SET_INCLUDE_CLOSED_COMMUNICATIONS,
            payload: status,
        };
    };

    const markCommentAsUnread = (commentId) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.post(
                    `communications/comment/${commentId}/mark`
                );
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(communicationsError(errorMsg));
            }
        };
    };

    const setCommunicationActivity = (activity) => {
        return {
            type: SET_COMMUNICATION_ACTIVITY,
            payload: activity,
        };
    };

    const fetchCommunicationActivity = (sortByNewFirst = false) => {
        return async (dispatch) => {
            try {
                let response = {};
                if (sortByNewFirst && sortByNewFirst === true) {
                    response = await axiosCall.get(
                        `communications/activity?sortByNewFirst=true`
                    );
                    dispatch(setCommunicationActivity(response.data.data));
                } else {
                    response = await axiosCall.get(`communications/activity`);
                    dispatch(setCommunicationActivity(response.data.data));
                }
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(communicationsError(errorMsg));
            }
        };
    };

    return {
        communicationsError,
        createNewCommunication,
        fetchComments,
        fetchCommunication,
        fetchCommunicationActivity,
        fetchCommunicationsList,
        fetchCommunicationsRequest,
        getCommentText,
        getComments,
        getCommunication,
        getCommunicationPartners,
        getCommunicationUsers,
        getCommunications,
        getCommunicationsList,
        getEmptyCommunication,
        getMentionableUsers,
        getSelectedCommunicationPartner,
        isPartnerConnected,
        markCommentAsUnread,
        postCommunicationComment,
        readCommunicationComments,
        setCommunicationStatus,
        setIncludeClosedCommunications,
        setIsCommunicationPartnerSelected,
        setIsViewAddingCommunication,
        setSelectedCommunication,
        storeAddedCommunication,
        storeAddedRequest,
        updateStoredCommunications,
        updateStoredRequests,
    };
};

export default initActions;
